import { createContext, useContext, useEffect, useState } from "react";
import { api, apiError, setAuthToken } from "@/lib/api";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

const tg = typeof window !== "undefined" ? window.Telegram?.WebApp : null;
export const isTelegram = !!(tg && tg.initData);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = logged

  const loadMe = async () => {
    try {
      const { data } = await api.get("/auth/session");
      setUser(data.user || false);
    } catch {
      setUser(false);
    }
  };

  const telegramLogin = async () => {
    try {
      tg.ready();
      tg.expand?.();
      document.documentElement.classList.toggle("dark", tg.colorScheme !== "light");
    } catch {}
    try {
      const { data } = await api.post("/auth/telegram-webapp", { init_data: tg.initData });
      if (data?._tg_token) setAuthToken(data._tg_token);
      const { _tg_token, ...u } = data;
      setUser(u);
      const p = window.location.pathname;
      if (p === "/" || p === "/login") window.location.replace("/painel");
    } catch {
      await loadMe();
    }
  };

  useEffect(() => {
    if (isTelegram) telegramLogin();
    else loadMe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    setAuthToken(null);
    setUser(false);
  };

  const refreshUser = loadMe;

  return (
    <AuthContext.Provider value={{ user, login, register, logout, refreshUser, apiError, isTelegram }}>
      {children}
    </AuthContext.Provider>
  );
}
